import { Typography } from "@mui/material"
import React from "react"
export const PanelOrders = (): JSX.Element => {
    return (
        <Typography variant="h5" color="secondary.main">
            Pedidos
        </Typography>
    )
}